import {objects, users} from "@atttomyx/shared-utils";
import {themes} from "@atttomyx/shared-constants";
import {LAYOUT_HORIZONTAL, VIEW_GRAPH} from "../constants";

export const sanitizeUser = (user) => {
    user.roles = users.normalizeRoles(user.roles);
    user.settings = sanitizeSettings(user.settings);
};

export const sanitizeProfile = (profile) => {
    profile.settings = sanitizeSettings(profile.settings);
};

const sanitizeSettings = (settings) => {
    const sanitized = settings || {};

    sanitized.theme = objects.defaultIfNullOrUndefined(sanitized.theme, themes.LIGHT);
    sanitized.view = objects.defaultIfNullOrUndefined(sanitized.view, VIEW_GRAPH);
    sanitized.layout = objects.defaultIfNullOrUndefined(sanitized.layout, LAYOUT_HORIZONTAL);

    return sanitized;
};
